import styled from 'styled-components'

export const Button = styled.button`
  outline-color: #002d63;
  width: 200px;
  height: 48px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  color: #ffffff;
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : ' #ff1744')};
  font-weight: bold;
`
